import { z } from "zod";

/**
 * Edit Organisation Form Validation Schema
 * ------------------------------------------------------------
 * All fields are required.
 */
export const editOrganisationSchema = z.object({
  organisationName: z.string().trim().min(1, "Organisation name is required"),

  industryType: z.string().trim().min(1, "Industry type is required"),

  contactPerson: z.string().trim().min(1, "Contact person is required"),

  contactEmail: z
    .string()
    .trim()
    .min(1, "Contact email is required")
    .email("Enter a valid email address"),

  contactNumber: z.string().trim().min(1, "Contact number is required"),

  addressLine1: z.string().trim().min(1, "Organisation address is required"),

  city: z.string().trim().min(1, "City is required"),

  state: z.string().trim().min(1, "State is required"),

  zip: z.string().trim().min(1, "Zip is required"),

  website: z.string().trim().optional(),
  deeplink: z
    .string()
    .trim()
    .optional()
    .refine(
      (value) =>
        !value || /^(https?:\/\/|[a-zA-Z][a-zA-Z0-9+.-]*:\/\/)/.test(value),
      {
        message: "Enter a valid deep link",
      },
    ),
});
